import type { ReportSummary } from '@/types/forensics';

const RISK_BAND_STYLES: Record<string, { bg: string; text: string; label: string }> = {
  high: { bg: 'bg-red-50 border-red-200', text: 'text-red-800', label: 'High Risk' },
  moderate: { bg: 'bg-orange-50 border-orange-200', text: 'text-orange-800', label: 'Moderate Risk' },
  low: { bg: 'bg-green-50 border-green-200', text: 'text-green-800', label: 'Low Risk' },
};

interface SummaryRiskCardProps {
  summary: ReportSummary;
}

export default function SummaryRiskCard({ summary }: SummaryRiskCardProps) {
  const style = RISK_BAND_STYLES[summary.riskBand] || RISK_BAND_STYLES.low;
  const pct = Math.round(summary.overallRiskScore * 100);

  return (
    <div className={`rounded-lg border p-4 ${style.bg}`}>
      <div className="flex items-center justify-between mb-2">
        <span className={`text-lg font-semibold ${style.text}`}>{style.label}</span>
        <span className={`text-2xl font-bold ${style.text}`}>{pct}%</span>
      </div>
      <p className="text-sm text-foreground/80">{summary.conclusionText}</p>
      {summary.caveats.length > 0 && (
        <div className="mt-3 pt-3 border-t border-current/10">
          <p className="text-xs font-medium text-muted-foreground mb-1">Caveats</p>
          <ul className="text-xs text-muted-foreground space-y-0.5">
            {summary.caveats.map((caveat, i) => (
              <li key={i}>- {caveat}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
